import { TFunction } from 'i18next';

/**
 * Returns a time-of-day greeting (morning/afternoon/evening) based on the local hour.
 */
export const greeting = (t: TFunction): string => {
  const hour = new Date().getHours();

  if (hour < 12) {
    return t('newDashboard.subscriptionDetails.goodMorning', 'Good morning');
  } else if (hour < 18) {
    return t('newDashboard.subscriptionDetails.goodAfternoon', 'Good afternoon');
  } else {
    return t('newDashboard.subscriptionDetails.goodEvening', 'Good evening');
  }
};
